import { Routes, Route } from "react-router-dom";
import NewsletterYearList from "./NewsletterYearList";
import NewsletterEntry from "./NewsletterEntry";
import Newsletter from "../Newsletter";

export default function NewsletterYearRoute() {
    return (
        <Routes>
            <Route index element={<Newsletter/>} />
            <Route path="/:year" element={<NewsletterYearList/>} />
            <Route path="/:year/:month" element={<NewsletterEntry/>} />
        </Routes>
    );
}
